import { Injectable } from '@angular/core';
import { BaseService } from '../core';
import { Brand } from '../dto/brand';

@Injectable({
  providedIn: 'root',
})
export class BrandService extends BaseService {
  getBrands() {
    return super.get<Brand[]>('/brand');
  }

  getBrand(id: number) {
    return super.get<Brand>(`/brand/${id}`);
  }

  makeBrandGrouping(brands: Brand[]) {
    const mapBrands = {};
    brands.forEach((brand) => {
      let firstLetter = brand.englishName[0].toUpperCase();
      if (firstLetter >= '0' && firstLetter <= '9') {
        firstLetter = '#';
      }

      if (!mapBrands[firstLetter]) {
        mapBrands[firstLetter] = [];
      }
      mapBrands[firstLetter].push(brand);
    });

    return Object.keys(mapBrands).map((key) => {
      return { firstLetter: key, brands: mapBrands[key] };
    });
  }

  filteredBrandWithKeyword(keyword: string, brands: Brand[]) {
    if (!keyword) {
      return { groupBrands: this.makeBrandGrouping(brands), brands };
    }

    keyword = keyword.toLowerCase();
    const searchBrands = brands.filter((list) => {
      return list.englishName.toLowerCase().includes(keyword);
    });
    return { groupBrands: this.makeBrandGrouping(searchBrands), brands: searchBrands };
  }
}
